<div class="c-modal c-modal--md" id="modal-{{vm.uid}}">
	<div mat-dialog-content class="c-modal__dialog" [ngStyle]="{'max-width': vm.isPsychologicalSafetySurvey && !vm.showNoContentMessage  ? '1200px' : '750px'}">
		<div class="c-modal__header">
			<div class="o-grid">
				<div class="o-grid__cell u-no-p">
					<p [ngStyle]="{'font-size': vm.titleFontSize}">{{ vm.surveyTitle }}</p>
				</div>
				<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
					<button id="closeButton" class="c-button c-button--icon c-button--tp c-modal__close" (click)="vm.close()">
						<i class="o-icon o-icon--x u-no-mr" aria-hidden="true"></i>
						<span class="u-sr-only">{{ 'Modal.Button.Close' | translate }}</span>
					</button>
				</div>
			</div>
		</div>
		<div class="c-modal__content">
			<div class="c-card c-card--height-fit" style="box-shadow:none;">
				<div class="o-grid o-grid--wrap" *ngIf="!vm.isPsychologicalSafetySurvey">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--center-h u-no-p" *ngIf="vm.initialized">
						<div class="chart-legend-container">
							<div class="chart-wrapper">
								<ng-google-charts [data]="vm.pieChartOptions"
												  [pngBase64Callback]="vm.getDistributionOfUsageGraph">
								</ng-google-charts>
							</div>
							<div class="custom-legend">
								<div *ngFor="let item of legendItems" class="legend-item">
									<span class="legend-color" [style.background-color]="item.color" ></span>
									<span class="legend-label">{{ item.label }}</span>
									<hr-employee-survey-popover *ngIf="!vm.isSmallSizeWindow && item.color !== colors[0]"
																placement="right"
																[data]="vm.getTranslationTextForPopover(item)"
																(click)="$event.preventDefault()"
																style="vertical-align:middle" class="u-osl-xs">
									</hr-employee-survey-popover>
								</div>
							</div>
						</div>
						<div *ngIf="!vm.showNoContentMessage && !vm.isSmallSizeWindow" class="chart-center-text" style="position: absolute;top: 50%;left: 30%;transform: translate(-50%, -50%);">
							<p class="c-text c-text--center c-text--bold" style="font-size: 16px;">{{ vm.filterText() }}</p>
							<p class="c-text c-text--center" style="white-space: pre;font-size: 16px;">{{ 'Surveys.Text_In_Chart' | translate }}</p>
						</div>
						<div *ngIf="vm.showNoContentMessage">
							<p class="c-text c-text--center">{{ 'Surveys.No_Content' | translate }}</p>
						</div>
					</div>
				</div>
				<div class="o-grid o-grid--wrap" *ngIf="vm.isPsychologicalSafetySurvey">
					<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--center-h u-no-p" *ngIf="vm.initialized">
						<div *ngIf="vm.showNoContentMessage">
							<p class="c-text c-text--center">{{ 'Surveys.No_Content' | translate }}</p>
						</div>
					</div>
					<div class="o-grid__cell o-grid__cell--w-45@md-and-up o-grid__cell--w-100 u-no-p" *ngIf="vm.initialized" style="margin-top: 10px; margin-right: 70px;">
						<p class="c-text" [innerHTML]="vm.introductionFeedback" *ngIf="vm.showIntroductionFeedback"></p>
						<p class="c-text" *ngIf="!vm.showIntroductionFeedback && !vm.showNoContentMessage">{{ 'Surveys.No_Safety_Info' | translate }}</p>
						<p class="c-text c-text--bold"  *ngIf="vm.inclusionSafetyShow">{{ 'Surveys.Inclusion_Safety_Title' | translate }}</p>
						<p class="c-text" *ngIf="vm.inclusionSafetyShow" style="margin-top: 10px;">
							{{ 'Surveys.Inclusion_Safety_Description' | translate | slice:0:150 }}
							<span *ngIf="'Surveys.Inclusion_Safety_Description' | translate as text">
      							<span *ngIf="text.length > 150">...</span>
							</span>
							<a class="c-text c-text--s19" href="javascript:void(0);" (click)="vm.openFullDescription('inclusion')">{{ 'Services.Button.Read_More' | translate }}</a>
						</p>
						<p class="c-text c-text--bold" style="margin-top: 10px;" *ngIf="vm.learnerSafetyShow">{{ 'Surveys.Learner_Safety_Title' | translate }}</p>
						<p class="c-text" *ngIf="vm.learnerSafetyShow" style="margin-top: 10px;">
							{{ 'Surveys.Learner_Safety_Description' | translate | slice:0:150 }}
							<span *ngIf="'Surveys.Learner_Safety_Description' | translate as text">
      							<span *ngIf="text.length > 150">...</span>
							</span>
							<a class="c-text c-text--s19" href="javascript:void(0);" (click)="vm.openFullDescription('learner')">{{ 'Services.Button.Read_More' | translate }}</a>
						</p>
						<p class="c-text c-text--bold" style="margin-top: 10px;" *ngIf="vm.contributorSafetyShow">{{ 'Surveys.Contributor_Safety_Title' | translate }}</p>
						<p class="c-text" *ngIf="vm.contributorSafetyShow" style="margin-top: 10px;">
							{{ 'Surveys.Contributor_Safety_Description' | translate | slice:0:150 }}
							<span *ngIf="'Surveys.Contributor_Safety_Description' | translate as text">
      							<span *ngIf="text.length > 150">...</span>
							</span>
							<a class="c-text c-text--s19" href="javascript:void(0);" (click)="vm.openFullDescription('contributor')">{{ 'Services.Button.Read_More' | translate }}</a>
						</p>
						<p class="c-text c-text--bold" style="margin-top: 10px;" *ngIf="vm.challengerSafetyShow">{{ 'Surveys.Challenger_Safety_Title' | translate }}</p>
						<p class="c-text" *ngIf="vm.challengerSafetyShow" style="margin-top: 10px;">
							{{ 'Surveys.Challenger_Safety_Description' | translate | slice:0:150 }}
							<span *ngIf="'Surveys.Challenger_Safety_Description' | translate as text">
      							<span *ngIf="text.length > 150">...</span>
							</span>
							<a class="c-text c-text--s19" href="javascript:void(0);" (click)="vm.openFullDescription('challenger')">{{ 'Services.Button.Read_More' | translate }}</a>
						</p>
					</div>
					<div class="o-grid__cell o-grid__cell--w-45@md-and-up o-grid__cell--w-100 u-no-p" style="margin-top: 10px;" *ngIf="vm.initialized">
						<div *ngFor="let question of vm.questions; let i = index">
							<div class="progress-container">
								<div class="c-text c-text--bold">{{ question.question }}</div>
								<div class="bar" style="margin-top: 12px;">
									<div class="fill" [ngStyle]="{'width': vm.getProgressBarWidth(question.averageScore) + '%', 'background-color' : vm.getBackgroundColor(i)}"></div>
									<div class="dot" [ngStyle]="{'left': vm.getProgressBarWidth(question.averageScore) + '%', 'border' : '2px solid ' + vm.getBackgroundColor(i)}" >{{ vm.formatScoreValue(question.averageScore) }}</div>
								</div>
								<div class="info-labels">
									<div class="c-text">{{ 'Surveys.Strongly_Disagree' | translate }}</div>
									<span class="c-text">{{ 'Surveys.Strongly_Agree' | translate }}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
				<loader-overlay *ngIf="!vm.initialized"></loader-overlay>
			</div>
		</div>
	</div>
</div>
